export enum EAudioProcessingStep {
  VOID,
  RECORDING,
  STORING,
}
